import {Box, Stack, Typography} from '@mui/material';
import React from 'react';
import {useTheme} from '@mui/material/styles';
import {Link} from "react-router-dom";
import Button from "@mui/material/Button";
import HomeAlt from "./HomeAlt";

export const NavItem = ({linkTo, text, sx}) => {
  return (
      <Button
        component={Link}
        to={linkTo}
        sx={{
          width: '100%',
          fontSize: '2vh',
          fontFamily: 'Share',
          color: 'white',
          transition: 'text-shadow 300ms ease, color 300ms ease',
          '&:hover': {
            background: 'transparent',
            textShadow: '0 0 2em lightblue, 0 0 2em lightyellow',
            fontWeight: 'bolder',
          },
            ...sx
        }}
      >
        {text}
      </Button>
  );
}

const links = [
  { to: '/mhdweb2/tools/plot1d', text: 'Plot1D' },
  { to: '/mhdweb2/tools/plot2d', text: 'Plot2D' },
  { to: '/mhdweb2/tools/data-products', text: 'Coronal Hole Maps' },
  { to: '/mhdweb2/tools/time-series', text: 'Time Series' },
  { to: '/mhdweb2/tools/spacecraft-mapping', text: 'Spacecraft Mapping' },
  { to: '/mhdweb2/tools/white-light', text: 'White Light' },
  { to: '/mhdweb2/tools/coronagraphs', text: 'Coronagraphs' },
  { to: '/mhdweb2/tools/euv', text: 'EUV & X-Rays' },
  { to: '/mhdweb2/tools/euv-comparison', text: 'EUV Imagers' },
  { to: '/mhdweb2/tools/data-access', text: 'Data Access' },
  { to: '/mhdweb2/api', text: 'API' },
];

const baseDelay = 1000;   // ms — when the first button starts
const step = 120;         // ms — stagger between items

const Home = () => {
  const theme = useTheme()

  return (
    <Box
      width="100%"
      height="100vh"
      display="flex"
      flexDirection="row"
      sx={{
        px: { xs: 1, sm: 2 },
        py: 0,
        mb:-20,
        position: 'relative',          // anchor for absolute children
        overflow: 'hidden',            // no scrollbars while animating
        backgroundColor: 'black',
        backgroundImage: `url(${process.env.PUBLIC_URL}/mhdweb_background.png)`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: '0% 50%',
        animation: 'bgPan 20s ease-out forwards',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: 'black',
          opacity: 1,
          pointerEvents: 'none',
          zIndex: 0,
          animation: 'fadeOut 2000ms ease-out forwards',
        },

        '@keyframes bgPan': { from: { backgroundPosition: '-100px 50%' }, to: { backgroundPosition: '0 50%' } },
        '@keyframes fadeOut': { to: { opacity: 0 } },
        '@keyframes mhdIn': { from: { transform: 'translateX(20px)', opacity: 0 }, to: { transform: 'translateX(0)', opacity: 1 } },
        '@keyframes typing': { from: { width: 0 }, to: { width: '3.7ch' } },
        '@keyframes opacityweb': { from: { opacity: 0 }, to: { opacity: 1 } }, // 3 letters: "web"
        '@keyframes caretBlink': { '50%': { borderColor: 'transparent' } },

        '@media (prefers-reduced-motion: reduce)': {
          animation: 'none',
          '&::before': { animation: 'none', opacity: 0 },
        },
      }}
    >
      <Typography
        component={Link}
        to={'/mhdweb2/about'}
        sx={{
          textDecoration: 'none',
          textAlign: 'right',
          position: 'absolute',
          top: '0em',
          right: '0.8em',
          zIndex: 1,
          fontSize: '10vh',
          fontFamily: 'Monoton',
          fontWeight: 'bold',
          color: 'white',
          opacity: 0,
          animation: 'mhdIn 1s cubic-bezier(.2,.8,.2,1) 200ms forwards',
        }}
      >
        MHD
      </Typography>

      <Typography
        sx={{
          position: 'absolute',
          // top: 'clamp(.1rem, 20vh, 1rem)',
          top: '0.9em',
          right: '0.1em',
          zIndex: 2,
          fontSize: '8vh',
          // fontSize: {xs: '6em', sm: '7em'},
          color: 'darkred',
          textShadow: '5px 5px 5px rgba(0,0,0,0.75)',
          fontFamily: 'Share',
          lineHeight: 1,
        }}
      >
        <Box
          component="span"
          sx={{
            display: 'inline-block',
            width: '4ch',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            opacity:0,
            borderRight: '.12em solid currentColor',
            animation:
              'typing 450ms steps(3, end) 500ms forwards, ' +
              'caretBlink 900ms step-end 450ms infinite, ' +
              'opacityweb 10ms step-end 550ms forwards',
            '@media (prefers-reduced-motion: reduce)': {
              animation: 'none',
              width: '3.7ch',
              borderRight: 0,
            },
          }}
        >
          web
        </Box>
      </Typography>

      <Stack
        spacing='0.1vh'
        sx={{
          position: 'absolute',
          top: '50%',
          right: '12vh',
          transform: 'translateY(-50%)',
          alignItems: 'stretch',
          zIndex: 1,

          '@keyframes slideInRight': {
            from: { opacity: 0, transform: 'translateX(40px)' },
            to:   { opacity: 1, transform: 'translateX(0)' }
          },
          '@media (prefers-reduced-motion: reduce)': {
            '& *': { animation: 'none !important', transform: 'none !important', opacity: 1 }
          }
        }}
      >
        {links.map((l, i) => (
            <NavItem
              sx={{
              opacity: 0,
              willChange: 'transform, opacity',
              animation: 'slideInRight 480ms ease-out forwards',
              animationDelay: `${baseDelay + i * step}ms`,
            }} linkTo={l.to} text={l.text}
            />
        ))}
      </Stack>
    </Box>
    // <HomeAlt />
  );
}

export default Home;